var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTouchPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_8239",
    "data-name": "Grupo 8239",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 228,
    height: 175.577,
    viewBox: "0 0 228 175.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6340",
    "data-name": "Rect\\xE1ngulo 6340",
    width: 228,
    height: 175.577,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6327",
    "data-name": "Rect\\xE1ngulo 6327",
    width: 228,
    height: 175.577,
    rx: 25.499,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6769",
    "data-name": "Trazado 6769",
    d: "M93.352,110.088c-2.028,2.528-.939,8.7-.973,9.768-.549,17.075-14.486,28.587-17.5,37.61-6.3,18.875-5.811,40.153,10.921,53.509,5.464,4.362,15.583,7.71,20.049-1.68,7.431-15.628.552-35.129-1.087-38.382-2.067-4.1-2.164-8.372-5.073-11.636,3.578-10.8,10.275-16.611,9.408-26.151-.449-4.95-.57-10.423-2.656-15.08-1.806-4.036-3.34-8.993-7.851-9.748a5.8,5.8,0,0,0-.962-.081,6.062,6.062,0,0,0-4.279,1.872",
    transform: "translate(-71.159 -108.216)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.265,
    y1: 0.968,
    x2: -0.258,
    y2: 0.968,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efb589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbcba0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6330",
    "data-name": "Rect\\xE1ngulo 6330",
    width: 72.198,
    height: 40.136,
    rx: 3.599,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.463,
    y1: 2.338,
    x2: -0.458,
    y2: 2.338,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9300ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5900aa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6338",
    "data-name": "Rect\\xE1ngulo 6338",
    width: 72.198,
    height: 37.388,
    rx: 3.599,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6337",
    "data-name": "Rect\\xE1ngulo 6337",
    width: 132.849,
    height: 82.903,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8238",
    "data-name": "Grupo 8238",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8222",
    "data-name": "Grupo 8222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8221",
    "data-name": "Grupo 8221",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6759",
    "data-name": "Trazado 6759",
    d: "M15.223,0H212.777A15.223,15.223,0,0,1,228,15.223V160.354a15.223,15.223,0,0,1-15.223,15.223H15.223A15.223,15.223,0,0,1,0,160.354V15.223A15.223,15.223,0,0,1,15.223,0",
    fill: "#9d00ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8224",
    "data-name": "Grupo 8224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8223",
    "data-name": "Grupo 8223",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6760",
    "data-name": "Trazado 6760",
    d: "M125.138,204.272c10-4.615,7.3-5.919,14.5-14.16,3.3-3.785,10.071-16.415,10.016-21.6-.054-5.075-5.946-14.331-9.489-17.388-8.686-7.5-3.654-13.8-12.651-20.871-5.947-4.675-17.246-19.126-25.052-10.2-3.307,3.78-5.639,8.61-8.223,12.839-2.427,3.974-3.566,11.723-7.842,14.285l1.159-.695c-6.276,4.078-12.98,9.2-16.974,15.581A191.785,191.785,0,0,0,60.3,179.633c-2.632,5.427-1.74,11.122-2.885,16.816-1.066,5.3-10.206,16.137-20.116,26.356h62.926c.228-.278.453-.559.684-.833,6.889-8.143,14.608-13.26,24.229-17.7",
    transform: "translate(-15.031 -47.228)",
    fill: "#fbcba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6761",
    "data-name": "Trazado 6761",
    d: "M187,206.376c6.235-1.728,11.451-5.719,17.76-7.374,3.927-1.03,5.235,1.072,8.581,3.3,4.993,3.329,10.145,6.953,14.975,10.568,2.706,2.025,5.038,3.379,2.02,6.254-1.822,1.735-5.161,2.606-7.509,2.98-6.21.987-10.141-1.253-15.122-4.625-.972-.658-2.822-2.427-3.895-2.438-1.659-.015-3.543,2.392-4.657,3.4-2.366,2.132-5.583,6.719-8.918,7.423-2.353.5-1.978-.047-2.414-2.51-.333-1.889-.617-3.712-1.024-5.6-.853-3.967-.537-6.783-.1-10.716C186.99,206.947,186.689,206.305,187,206.376Z",
    transform: "translate(-75.059 -80.087)",
    fill: "#fbcba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6762",
    "data-name": "Trazado 6762",
    d: "M192.306,137.084c12.992,1.55,26.636,1.208,39.686,1.87,2.306.117,10.718.476,11.269,2.807,1.638,6.934-14.248,12.454-19.773,11.994-11.125-.927-22.428-2.049-33.768-2.165a36.8,36.8,0,0,1,.971-7.146c.438-2.164,1.821-4.742,1.581-6.892.257-.18-.161-.847.033-.468",
    transform: "translate(-76.455 -55.197)",
    fill: "#fbcba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6763",
    "data-name": "Trazado 6763",
    d: "M142.273,122.241c10.16-3.084,17.06-14.1,26.6-18.565,4.573-2.14,11-.776,15.8-.295,5.885.589,11.948.673,17.946.681,2.9,0,5.946-.53,8.958-.688,2.865-.15,5.7-.916,6.566,2.165,1.48,5.278-4.141,10.227-8.113,12.605-5.193,3.109-10.051,3.726-16.1,3.727-4.792,0-11.06-2.955-15.774-1.816-3.457.835-7.086,5.857-9.887,7.972a107.559,107.559,0,0,0-10.45,8.5c-4.216,4.073-9.936,6.77-12.7,0C143.553,132.675,137.334,123.74,142.273,122.241Z",
    transform: "translate(-56.58 -41.31)",
    fill: "#fbcba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6764",
    "data-name": "Trazado 6764",
    d: "M140.9,164.686c10.536,1.315,21.324-5.944,31.858-6.141,5.049-.094,10.365,3.765,14.557,6.158,5.137,2.931,10.641,5.474,16.118,7.919,2.645,1.181,5.646,1.934,8.463,3.015,2.679,1.028,5.581,1.482,5.117,4.647-.8,5.424-7.944,7.658-12.541,8.215-6.009.728-10.7-.684-16.223-3.142-4.378-1.948-8.9-7.2-13.67-8.073-3.5-.644-8.857,2.469-12.276,3.261a107.533,107.533,0,0,0-13.006,3.518c-5.509,2.006-11.832,2.143-11.6-5.164C137.823,174.737,135.777,164.047,140.9,164.686Z",
    transform: "translate(-55.369 -63.891)",
    fill: "#fbcba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6765",
    "data-name": "Trazado 6765",
    d: "M192.86,170.047H143.806a9.1,9.1,0,0,1-9.1-9.1V38.941a9.1,9.1,0,0,1,9.1-9.1H192.86a9.1,9.1,0,0,1,9.1,9.1V160.95A9.1,9.1,0,0,1,192.86,170.047Z",
    transform: "translate(-54.285 -12.027)",
    fill: "#32314c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6766",
    "data-name": "Trazado 6766",
    d: "M173.772,41.925a1.592,1.592,0,1,1-1.592,1.592,1.592,1.592,0,0,1,1.592-1.592",
    transform: "translate(-69.387 -16.895)",
    fill: "#44446b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6767",
    "data-name": "Trazado 6767",
    d: "M192.86,29.844h-9.417q-.724.451-1.422.92c-12.337,8.256-22.95,19.946-27.077,34.2-1.665,5.746-2.241,11.746-3.507,17.593-2.9,13.389-9.352,25.746-16.731,37.294v41.1a9.1,9.1,0,0,0,9.1,9.1H192.86a9.1,9.1,0,0,0,9.1-9.1V38.941A9.1,9.1,0,0,0,192.86,29.844Z",
    transform: "translate(-54.285 -12.027)",
    fill: "#44446b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6325",
    "data-name": "Rect\\xE1ngulo 6325",
    width: 11.416,
    height: 1.963,
    transform: "matrix(0.992, -0.124, 0.124, 0.992, 108.71, 26.151)",
    fill: "#44446b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6326",
    "data-name": "Rect\\xE1ngulo 6326",
    width: 61.927,
    height: 108.599,
    transform: "translate(83.085 33.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6768",
    "data-name": "Trazado 6768",
    d: "M192.239,43.984h-9.308a.333.333,0,1,1,0-.666h9.308a.333.333,0,1,1,0,.666",
    transform: "translate(-73.585 -17.457)",
    fill: "#9d00ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8226",
    "data-name": "Grupo 8226",
    transform: "translate(42.483 64.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8225",
    "data-name": "Grupo 8225",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6328",
    "data-name": "Rect\\xE1ngulo 6328",
    width: 81.35,
    height: 119.149,
    transform: "translate(-39.551 14.2) rotate(-21.007)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8228",
    "data-name": "Grupo 8228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8227",
    "data-name": "Grupo 8227",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6770",
    "data-name": "Trazado 6770",
    d: "M166.3,220.324H147a2.843,2.843,0,0,1-2.843-2.843v-9.631A2.843,2.843,0,0,1,147,205.007H166.3a2.843,2.843,0,0,1,2.843,2.844v9.631a2.843,2.843,0,0,1-2.843,2.843",
    transform: "translate(-58.092 -82.616)",
    fill: "#007eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6771",
    "data-name": "Trazado 6771",
    d: "M218.2,220.324H198.892a2.843,2.843,0,0,1-2.843-2.843v-9.631a2.844,2.844,0,0,1,2.843-2.844H218.2a2.843,2.843,0,0,1,2.842,2.844v9.631a2.843,2.843,0,0,1-2.842,2.843",
    transform: "translate(-79.006 -82.616)",
    fill: "#9d00ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6772",
    "data-name": "Trazado 6772",
    d: "M166.3,184.463H147a2.843,2.843,0,0,1-2.843-2.843V171.99A2.843,2.843,0,0,1,147,169.146H166.3a2.843,2.843,0,0,1,2.843,2.844v9.631a2.843,2.843,0,0,1-2.843,2.843",
    transform: "translate(-58.092 -68.164)",
    fill: "#007eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6773",
    "data-name": "Trazado 6773",
    d: "M218.2,184.463H198.892a2.843,2.843,0,0,1-2.843-2.843V171.99a2.844,2.844,0,0,1,2.843-2.844H218.2a2.843,2.843,0,0,1,2.842,2.844v9.631a2.843,2.843,0,0,1-2.842,2.843",
    transform: "translate(-79.006 -68.164)",
    fill: "#9d00ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6774",
    "data-name": "Trazado 6774",
    d: "M166.3,148.6H147a2.843,2.843,0,0,1-2.843-2.843v-9.631A2.843,2.843,0,0,1,147,133.286H166.3a2.843,2.843,0,0,1,2.843,2.843v9.631A2.843,2.843,0,0,1,166.3,148.6",
    transform: "translate(-58.092 -53.713)",
    fill: "#007eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6775",
    "data-name": "Trazado 6775",
    d: "M218.2,148.6H198.892a2.843,2.843,0,0,1-2.843-2.843v-9.631a2.843,2.843,0,0,1,2.843-2.843H218.2a2.843,2.843,0,0,1,2.842,2.843v9.631A2.843,2.843,0,0,1,218.2,148.6",
    transform: "translate(-79.006 -53.713)",
    fill: "#9d00ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8230",
    "data-name": "Grupo 8230",
    transform: "translate(86.061 36.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8229",
    "data-name": "Grupo 8229",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6776",
    "data-name": "Trazado 6776",
    d: "M98.356,58.9l39.869,48.371,87.011-22.165L185.367,36.739Z",
    transform: "translate(-125.697 -51.939)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8235",
    "data-name": "Grupo 8235",
    transform: "translate(86.061 36.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8234",
    "data-name": "Grupo 8234",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8233",
    "data-name": "Grupo 8233",
    transform: "translate(-25.72 -26.375)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8232",
    "data-name": "Grupo 8232",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8231",
    "data-name": "Grupo 8231",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6331",
    "data-name": "Rect\\xE1ngulo 6331",
    width: 46.773,
    height: 34.918,
    transform: "translate(0 56.668) rotate(-74.991)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6332",
    "data-name": "Rect\\xE1ngulo 6332",
    width: 46.128,
    height: 34.273,
    transform: "translate(0.395 56.44) rotate(-74.991)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10.001,
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6333",
    "data-name": "Rect\\xE1ngulo 6333",
    width: 20.045,
    height: 89.235,
    transform: "translate(11.659 59.794) rotate(-74.991)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6334",
    "data-name": "Rect\\xE1ngulo 6334",
    width: 19.401,
    height: 88.59,
    transform: "translate(12.053 59.566) rotate(-74.991)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10.001,
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6335",
    "data-name": "Rect\\xE1ngulo 6335",
    width: 20.045,
    height: 89.235,
    transform: "translate(41.467 19.361) rotate(-74.991)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6336",
    "data-name": "Rect\\xE1ngulo 6336",
    width: 19.401,
    height: 88.59,
    transform: "translate(41.862 19.133) rotate(-74.991)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10.001,
    strokeWidth: 1.08
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8237",
    "data-name": "Grupo 8237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8236",
    "data-name": "Grupo 8236",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6777",
    "data-name": "Trazado 6777",
    d: "M187.858,92.735l3.288-7.28a.194.194,0,0,1,.184-.119h.108a.194.194,0,0,1,.184.119l3.267,7.28a.191.191,0,0,1-.078.259.194.194,0,0,1-.106.022h-.433a.2.2,0,0,1-.184-.119l-.8-1.785h-3.84l-.79,1.785a.2.2,0,0,1-.184.119h-.433a.19.19,0,0,1-.206-.174.2.2,0,0,1,.022-.107M193,90.442c-.53-1.179-1.049-2.369-1.579-3.548h-.087l-1.579,3.548Z",
    transform: "translate(-75.696 -34.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6778",
    "data-name": "Trazado 6778",
    d: "M201.81,87.9a1.893,1.893,0,0,1,1.567.767.214.214,0,0,1-.036.3l-.008.006-.208.175c-.164.153-.219.044-.318-.044a1.352,1.352,0,0,0-1.008-.46,1.572,1.572,0,0,0-.011,3.134,1.458,1.458,0,0,0,1.162-.57c.131-.131.208-.109.328-.021l.121.088a.22.22,0,0,1,.08.3l0,.006a1.965,1.965,0,0,1-1.678.92,2.252,2.252,0,0,1-2.247-2.258v-.033a2.308,2.308,0,0,1,2.257-2.312",
    transform: "translate(-80.417 -35.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6779",
    "data-name": "Trazado 6779",
    d: "M208.023,87.769h-.559a.208.208,0,0,1-.208-.208V87.32a.2.2,0,0,1,.194-.208h.573V85.9a.216.216,0,0,1,.208-.208l.35-.022a.206.206,0,0,1,.2.208v1.238h1.34a.2.2,0,0,1,.208.194.059.059,0,0,1,0,.014v.241a.208.208,0,0,1-.208.208h-1.34v2.564c0,.438.11.526.362.526a2.092,2.092,0,0,0,.8-.241c.164-.088.208-.022.263.064l.164.274c.077.131.044.2-.077.274a2.866,2.866,0,0,1-1.258.373c-.876,0-1.008-.526-1.008-1.205Z",
    transform: "translate(-83.522 -34.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6780",
    "data-name": "Trazado 6780",
    d: "M215.865,87.9a2.3,2.3,0,1,1-2.177,2.424c0-.044,0-.089,0-.134a2.246,2.246,0,0,1,2.18-2.291m0,3.89A1.508,1.508,0,0,0,217.29,90.2v-.012a1.431,1.431,0,1,0-2.849,0,1.508,1.508,0,0,0,1.413,1.6h.011",
    transform: "translate(-86.113 -35.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6781",
    "data-name": "Trazado 6781",
    d: "M217.316,97.665h-1.457a.383.383,0,0,1,0-.767h1.457a.383.383,0,0,1,0,.767",
    transform: "translate(-86.835 -39.049)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchPink);
export default __webpack_public_path__ + "static/media/touchPink.5b5300a1.svg";
export { ForwardRef as ReactComponent };